import * as types from '../Constants';

export const liaNumberReducer = (state = {}, action) => {
  switch (action.type) {
    case types.GET_LIA_NUMBER_SUCCESS:
      return { ...state, liaNumberRes: action.payload };
    case types.GET_LIA_NUMBER_FAILURE:
      if (action.payload.response === 'undefined') {
        window.location.assign('/login');
      }

    case types.UPDATE_LIA_NUMBER_SUCCESS:
      return { ...state, updateLiaNumberRes: action.payload };
    case types.UPDATE_LIA_NUMBER_FAILURE:
      if (action.payload.response === 'undefined') {
        window.location.assign('/login');
      }

    default:
      return state;
  }
};
